import Endpoint from "../../services/api/endpoint";
import { IRole } from "../../utils/types/models";
import { createEntityReducer } from "./entityReducer";

export default createEntityReducer<IRole>(Endpoint.Roles, Endpoint.RolesList);